






































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import {Action, Getter} from 'vuex-class'
import Carga from '@/model/resource/Carga'
import {Role} from '@/enums/Role'
import {DeliveryStatus} from '@/enums/DeliveryStatus'
import Responsavel from '@/model/resource/Responsavel'
import * as Helper from '@/helpers'

@Component
export default class RenderCargaAction extends Vue {
  @Getter('auth/responsavel') user!: Responsavel
  @Getter('auth/role') role!: Role
  @Prop({required: true}) model!: Carga
  Helper = Helper

  DeliveryStatus = DeliveryStatus

  showEditCarga() {

      return (this.user.$id === this.model.idResponsavelCriadorFk ||
          [Role.RESPONSAVEL, Role.RESPONSAVEL_CHILD, Role.RESPONSAVEL_GROUP_MASTER].includes(this.role)) &&
          (this.model && this.model.statusCarga && this.model.statusCarga.$id === DeliveryStatus.PENDING)
  }

  showEditCargaWithPermitirDevolverNota() {

      return (this.user.$id === this.model.idResponsavelCriadorFk ||
          [Role.RESPONSAVEL, Role.RESPONSAVEL_CHILD, Role.RESPONSAVEL_GROUP_MASTER].includes(this.role)) &&
          (this.model && this.model.statusCarga && this.model.statusCarga.$id === DeliveryStatus.STARTED)
          && Helper.getPermitirDevolverNota()
  }

  showEditCargaWithPermitirDevolverNotaFinalizadaParaNaoIniciada() {
    return (this.user.$id === this.model.idResponsavelCriadorFk ||
        [Role.RESPONSAVEL, Role.RESPONSAVEL_CHILD, Role.RESPONSAVEL_GROUP_MASTER].includes(this.role)) &&
        (this.model && this.model.statusCarga && this.model.statusCarga.$id === DeliveryStatus.FINISHED)
        && Helper.getPermitirDevolverNotaFinalizadaParaNaoIniciada()
  }

  showAuditCarga() {
    return this.model && this.model.statusCarga
        && this.model.statusCarga.$id === DeliveryStatus.FINISHED
        && this.$route.name === 'listDelivery'
  }

  openModalConfirmEdit() {
    this.$modal.open('modalConfirmEditCarga', this.model.$id)
  }

  openModalAudit() {
    this.$modal.open('modalAudit', this.model.$id)
  }

  openModalDevolverNotaFinalizadaParaNaoIniciada() {
    this.$modal.open('modalCargaFinalizadaParaNaoIniciada', this.model.$id)
  }
}
